import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import { HeaderFilterOption, LoadOptions } from '../shared/models/shared.model';
import { Observable } from 'rxjs';
import { CountryDataMappingResultModel } from '../shared/models/country-data.model';
import { HeaderFilterData } from '../shared/models/product.model';

@Injectable({
  providedIn: 'root'
})
export class CountryDataService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/countrydatamapping';

  constructor(private httpClient: HttpClient) { }

  public getCountryMappingGrid(param: LoadOptions): Observable<CountryDataMappingResultModel> {
	return this.httpClient
		.post<CountryDataMappingResultModel>(
		this.url + `/getCountryMappingGrid/`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersCompanyMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersCompanyMapping`, param,
		{ headers: this.headers }
		);
  }

  public mappingAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/mappingAction', param,
		{ headers: this.headers }
		);
  }
}
